import React, { useState, createContext } from 'react';

export const AuthUserContext = createContext({});

export const AuthUserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [signedOut, setSignedOut] = useState(false)

  return (
    <AuthUserContext.Provider value={{ user, setUser, signedOut, setSignedOut }}>
      {children}
    </AuthUserContext.Provider>
  );
};
